module.exports = __webpack_public_path__ + "static/media/BarlowCondensed-ExtraLight.1b89a605.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/BarlowCondensed-ExtraLight.ttf
// module id = 2865
// module chunks = 51